let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fDTYR")).then(() => parcelRequire('2d5K5'));